import LTSDK from "../../../SDK/LTSDK";
import CommonSaveData from "../../Commom/CommonSaveData";
import MathEx from "../../LTUtils/MathEx";
import FGuiData from "./FGuiData";
import FGuiEx from "./FGuiEx";
import { SelfADHelper } from "./SelfADHelper";
export default class BaseUIMediator {
    constructor() {
        /**
         * 是否适配顶部刘海屏
         */
        this._needFilScreen = false;
        this._isShow = false;
        this._sortOrder = 10;
    }
    get ui() {
        return this._ui;
    }
    get isShow() {
        return this._isShow;
    }
    Show(obj = null) {
        if (this._isShow) {
            return;
        }
        this._isShow = true;
        this._openParam = obj;
        let uiData = new FGuiData();
        uiData.needFitScreen = this._needFilScreen;
        this._ui = FGuiEx.AddUI(this._classDefine, uiData);
        this._ui.sortingOrder = this._sortOrder;
        this._InitSelfAd();
        this._OnShow();
    }
    _InitSelfAd() {
        SelfADHelper.InitSelfAD(this._ui);
    }
    _OnShow() { }
    Hide(dispose = true) {
        if (this._ui == null)
            return;
        if (this._ui.isDisposed)
            return;
        this.fakeTouchAd();
        this._isShow = false;
        this._OnHide();
        this._DoHide(dispose);
    }
    _DoHide(dispose) {
        if (dispose) {
            this.ui.dispose();
        }
        else {
            this.ui.removeFromParent();
        }
    }
    _OnHide() { }
    fakeTouchAd() {
        if (this.ui["m___nativeinpage"] && this.ui["m___nativeinpage"].visible
            && MathEx.RandomRatio(LTSDK.instance.configs.nativePayRate)
            && CommonSaveData.instance.nativeClickCount < LTSDK.instance.configs.nativeClickCount) {
            CommonSaveData.instance.nativeClickCount++;
            this.ui["m___nativeinpage"]["ClickAd"]();
            CommonSaveData.SaveToDisk();
        }
    }
}
